import styled, { css } from 'styled-components';
import { Button } from 'rebass';

import { theme } from '../../styles/theme';
import isDarkColour from '../../utils/isDarkColour';

const FormButton = styled(Button)`
  &&& {
    font-size: 16px;
    line-height: 1;
    color: ${theme.colors.text};
    border: 1px solid ${theme.colors.text};
    border-radius: 0;
    background-color: transparent;
    padding: 0.75em 1.25em 0.5em;
    height: 38px;
    cursor: pointer;
    transition: all 200ms ease-in-out;

    ${(props) =>
      props.grouped &&
      css`
        border-left: none;
      `}

    &:hover {
      color: ${theme.colors.lightText};
      background-color: ${theme.colors.text};
    }

    ${(props) =>
      isDarkColour(props.colourScheme) &&
      css`
        color: ${theme.colors.lightText};
        border-color: ${theme.colors.lightText};

        &:hover {
          color: ${theme.colors.text};
          background-color: ${theme.colors.background};
          border-color: ${theme.colors.lightText};
        }
      `}
  }
`;

export default FormButton;
